<template>
  <div
    class="text-center"
  >
    <v-dialog
      v-model="dialog"
      max-width="500px"
      width="90%"
    >
      <v-card>
        <v-card-title
          class="text-h5"
        >
          Atenção
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-alert
            dense
            text
            :type="modalType"
            class="mt-5"
          >
            <div>
              {{title}}
            </div>
            <div>
              {{message}}
            </div>
          </v-alert>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click="close"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      callBack: undefined,
      modalType: 'error',
      title: '',
      message: ''
    };
  },
  watch: {
    dialog(value) {
      if (!value) {
        if (this.callBack) {
          this.callBack();
        }
      }
    }
  },
  methods: {
    Load(open, msgTitle, msgText, callBackClose, modalType) {
      this.title = msgTitle;
      this.message = msgText;
      this.callBack = callBackClose;
      if (modalType) {
        this.modalType = modalType;
      }
      this.dialog = open;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
